import { css } from "@emotion/core"

const theme = {
    color: {
        darktext: "#303030",
        regtext: "#505050",
        lighttext: "#b2b2b2",

        black: "#000",
        white: "#fff",

        primary: "#2cb1bc",
        light: "#d7f7f9",

        darkbg: "#182533",
        bg: "#f4fafb",
        border: "#b2b2b2",
        subtlegrey: "#e6e6e6",
        nearwhite: "#f2f2f2",

        menubg: "#182533",
        menufg: "#fff",
    },

    font: {
        size: [
            "0rem", //0
            "0.6rem", //1
            "0.8rem", //2
            "0.85rem", //3
            "0.9rem", //4
            "0.95rem", //5
            "1rem", //6
            "1.1rem", //7
            "1.2rem", //8
            "1.4rem", //9
            "1.6rem", //10
            "1.8rem", //11
            "2rem", //12
            "3rem", //13
            "4rem", //14
        ],
        weight: {
            light: 300,
            regular: 400,
            semibold: 600,
            bold: 700,
        },
        spacing: ["0rem", "0.018rem", "0.0225rem", "0.042rem", "0.051rem", "0.0896rem", "0.011rem", "0.1408rem"],
        height: [0, 1, 1.33, 1.66, 2],
    },

    space: [
        "0rem", //0
        "0.3125rem", //1
        "0.625rem", //2
        "0.9375rem", //3
        "1.25rem", //4
        "1.5625rem", //5
        "1.875rem", //6
        "2.5rem", //7
        "3.75rem", //8
        "5rem", //9
        "6.25rem", //10
    ],

    radius: {
        regular: "2px",
        large: "4px",
    },
    breakpoint: {
        small: "812px", //below this, mobile. between small and large, tablet.
        large: "1224px", //above this, is desktop
    },

    sitewide: {
        containerWidth: "58rem",
        sideWidth: "calc(50% - (58rem / 2))",
    },
}

const mixin = {
    desktopstyle: `
        @media only screen and (min-width: 1224px)
    `,
    desktopandtabletstyle: `
        @media only screen and (min-width: 812px)
    `,
    tabletandphonestyle: `
        @media only screen and (max-width: 1224px)
    `,
    phonestyle: `
        @media only screen and (max-width: 812px)
    `,

    chunkyUnderline: (color, size = 0.3, position = 0) => {
        return css`
            background-image: linear-gradient(
                transparent 0%,
                transparent ${(1 - size - position) * 100}%,
                ${color} ${(1 - size - position) * 100}%,
                ${color} ${(1 - position) * 100}%,
                transparent ${(1 - position) * 100}%,
                transparent
            );
        `
    },

    defaultEndsPadding: css`
        padding-top: ${theme.space[7]};
        padding-bottom: ${theme.space[7]};
        @media only screen and (max-width: ${theme.breakpoint.large}) {
            padding-top: ${theme.space[6]};
            padding-bottom: ${theme.space[6]};
        }
    `,

    fullwidth: css`
        width: 100vw;
        left: 50%;
        right: 50%;
        margin-left: -50vw;
        margin-right: -50vw;
    `,

    constantLink: css`
        a:link,
        a:visited {
            text-decoration: none;
            color: currentColor;
        }
    `,

    defaultSidePadding: css`
        @media only screen and (max-width: ${theme.breakpoint.large}) {
            padding-left: 10vw;
            padding-right: 10vw;
        }
        @media only screen and (max-width: ${theme.breakpoint.small}) {
            padding-left: 5vw;
            padding-right: 5vw;
        }
    `,

    noSelect: css`
        -webkit-user-select: none;
        -webkit-touch-callout: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    `,
}

const globalStyle = css`
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    html {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        font-family: "Open Sans", sans-serif;
        font-size: 18px;
        ${mixin.tabletandphonestyle} {
            font-size: 2.125vw;
        }
        ${mixin.phonestyle} {
            font-size: 4vw;
        }
    }

    body {
        box-sizing: border-box;
        background-color: white;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;

        *:link,
        *:visited {
            text-decoration: none;
            color: currentColor;
        }

        line-height: 1.66;
        color: #505050;

        h1 {
            font-family: "Roboto Condensed", sans-serif;
            color: #303030;
            font-weight: 700;
            line-height: 1.25;
            text-transform: uppercase;
            font-size: 2rem;
        }

        h2,
        h3,
        h4,
        h5,
        h6 {
            font-family: "Roboto Condensed", sans-serif;
            color: #303030;
            font-weight: 700;
            line-height: 1.25;
            text-transform: uppercase;
        }
    }
`

export default theme
export { mixin, globalStyle }
